import React, { FC, useCallback, useEffect, useRef, useState } from 'react'
import { Modal, Button, Textarea } from '@wmgtech/legato'
import { ModalAPI } from './types'

import styles from './story-shared-modal.module.scss'

interface StoryShareModalProps extends Partial<Omit<ModalAPI, 'id'>> {
  isOpen: boolean
  handleClose(): void
  children?:(node: React.ReactNode) => React.ReactNode
}

export const StoryShareModal: FC<StoryShareModalProps> = ({
  isOpen,
  title = 'Share with the Global Hub and Affiliate Zones!',
  description = 'Please confirm whether you would like to share this story. By sharing, it has the potential to be seen by 1,524 users  in the Global Hub and affiliate regions where your project has been localized.',
  children = node => node,
  handleClose,
  onShare,
}) => {

  const [pending, setPending] = useState<boolean>(false)

  const textAreaRef = useRef<HTMLTextAreaElement | null>()

  const modalStatus = useRef<boolean>()

  useEffect(
    () => {
      modalStatus.current = true
      return () => {
        modalStatus.current = false
      }
    },
    []
  )

  const handleSubmit = useCallback(
    async () => {
      if (typeof onShare === 'function' && textAreaRef.current) {
        setPending(true)
        try {
          await onShare(textAreaRef.current.value.trim())
        } finally {
          if (modalStatus.current) {
            setPending(false)
            handleClose()
          }
        }
      }
    },
    [handleClose, onShare],
  )

  return (
    <Modal
      isOpen={isOpen}
      className={styles.modal}
      title={<>👍🏼<span>{title}</span></>}
      onClose={handleClose}
      footer={(
        <>
          <Button
            htmlType="button"
            colorType="info"
            containerStyle="outline"
            onClick={handleClose}
            disabled={pending}
          >Cancel</Button>
          <Button
            htmlType="button"
            colorType="info"
            icon="share-from-square"
            onClick={handleSubmit}
            disabled={pending}
          >Share Story</Button>
        </>
      )}
    >
      <div className={styles.description}>
        {
          description
        }
      </div>
      {
        children(
          <Textarea
            placeholder="Add additional context..."
            textareaRef={el => { textAreaRef.current = el }}
          />
        )
      }
    </Modal>
  )
}
